import { useEffect, useState }  from "react";
import { useDispatch, useSelector } from "react-redux";
import ApiVolumesTrims from '../../api/volumestrims';
import ListWithControls from "../general/ListWithControls";
import AddNewTrimForm from "./AddNewTrimForm";

import Bodytypes from "./Bodytypes";

import { FaTimes, FaEye, FaEyeSlash, FaStar, FaRegStar } from 'react-icons/fa';
import TrimsSynonyms from "./TrimsSynonyms";

import { log as actionsLog } from '../../store/actions';

const { addToLog } = actionsLog;

const Trims = ({ selectedModel, selectedVolume, trims, notifyTrims }) => {

    let dispatch = useDispatch();

    let [selectedTrim, setSelectedTrim] = useState(null);

    useEffect(() => {
        setSelectedTrim(null);
    }, [selectedVolume]);

    const listClasses = id => {
        const common = 'flex items-center p-2 border-b border-gray-700';
        const specific = selectedTrim?.id == id ?
            "bg-gray-700 text-white" : "cursor-pointer hover:bg-gray-700";
        return `${common} ${specific}`;
    }

    const selectTrim = trim => {
        setSelectedTrim(trim);
    }

    const deleteTrimForSelectedVolume = (e, trim) => {
        let proceed = window.confirm(`Delete trim: ${trim.name}?`);
        if (proceed) {
            ApiVolumesTrims.deleteTrim(selectedModel.id, selectedVolume.id, trim.id).then(resp => {
                dispatch(addToLog(resp));
                notifyTrims();
            });
        }
        e.stopPropagation();
    }

    const updateHideVolume = (e, trim) => {
        const newValue = !trim.hideVolume;
        let proceed = window.confirm(`${newValue ? 'Hide' : 'Show'} volume for trim: ${trim.name}?`);
        if (proceed) {
            ApiVolumesTrims.updateHideVolumeForTrim(selectedModel.id, selectedVolume.id, trim.id, newValue).then(resp => {
                dispatch(addToLog(resp));
                notifyTrims();
            });
        }
        e.stopPropagation();
    }

    const setDefaultTrim = (e, trim) => {
        if (!trim.defaultTrim) {
            let proceed = window.confirm(`Set default trim: ${trim.name}?`);
            if (proceed) {
                ApiVolumesTrims.setDefaultTrim(selectedModel.id, selectedVolume.id, trim.id).then(resp => {
                    dispatch(addToLog(resp));
                    notifyTrims();
                });
            }
            e.stopPropagation();
        }
    }

    const eyeClass = trim => {
        return (
            trim.hideVolume ? 
            <FaEyeSlash /> :
            <FaEye />
        )
    }

    const starClass = trim => {
        return (
            trim.defaultTrim ? 
            <FaStar /> :
            <FaRegStar />
        )
    }

    return (
        <div>
            <div className="border border-gray-700 mb-2">
                <div className="text-lg p-2 bg-gray-900 flex items-center justify-between">
                    Trims for selected volume
                </div>
                <ul style={{ maxHeight: 300, overflowY: "auto" }}>
                    {trims.map(item => (
                        <li className={listClasses(item.id)} onClick={() => selectTrim(item)} key={item.id}>
                            {item.name} [{item.id}]
                            <div className="ml-auto flex">
                                <span className="leading-none ml-2 p-1 text-gray-300 rounded border border-gray-600 rounded-xl text-sm bg-gray-800">
                                    {item.fuelType.abbrName}
                                </span>
                                <button title={item.hideVolume ? 'Show volume' : 'Hide volume'} className="ml-2 p-1 text-gray-300 hover:text-white rounded border border-gray-600 hover:bg-yellow-500"
                                    onClick={e => updateHideVolume(e, item)}>
                                    { eyeClass(item) }
                                </button>
                                <button title={item.defaultTrim ? 'Remove default trim' : 'Set default trim'} className="ml-2 p-1 text-gray-300 hover:text-white rounded border border-gray-600 hover:bg-yellow-500"
                                    onClick={e => setDefaultTrim(e, item)}>
                                    { starClass(item) }
                                </button>
                                <button className="ml-2 p-1 text-gray-300 hover:text-white rounded border border-gray-600 hover:bg-yellow-500"
                                    onClick={e => deleteTrimForSelectedVolume(e, item)}>
                                    <FaTimes />
                                </button>
                            </div>
                        </li>
                    ))}
                </ul>
                <AddNewTrimForm notifyTrims={notifyTrims} selectedModel={selectedModel} selectedVolume={selectedVolume} selectedTrim={selectedTrim} trims={trims}/>
            </div>
            {
                selectedTrim ? 
                    <Bodytypes selectedModel={selectedModel} selectedVolume={selectedVolume} selectedTrim={selectedTrim} />
                : <></>
            }
            {
                selectedTrim ? 
                    <TrimsSynonyms selectedModel={selectedModel} selectedVolume={selectedVolume} selectedTrim={selectedTrim} />
                : <></>
            }
        </div>
    );
}

export default Trims;